module.exports = __webpack_public_path__ + "img/logo_inbi.9154b50a.png";